export default __webpack_public_path__ + "static/media/progressbar-check-icon.99ecfc80.svg";